// Dashboard UI — Night Bureau
// La feature Tours a ete retiree le 2026-04-17. Ce module est conserve comme
// squelette pour un futur dashboard admin (redirect vers /users pour l'instant).
//
// Le fichier et dashboard.html sont proteges par le hook pre-commit :
// ne pas supprimer sans demande explicite.

console.log('Dashboard UI module loaded (post-Tours-removal stub)');
